function getPrefixByCountryCode(countryCode: string): string {
  switch (countryCode.toLowerCase()) {
    case 'ee':
      return '+372';
    case 'lt':
      return '+370';
    default:
      return '';
  }
}

export const PhonePrefixUtil = {
  getPrefixByCountryCode,
};
